// extracted by mini-css-extract-plugin
export default {"divider":"styles_divider__a4nUb","bar":"styles_bar__zd7BN"};